export enum DlsEntityTypes {
    Region = "Region",
    BrandCo = "BrandCo",
    MarketCo = "MarketCo",
    BrandCoMarketCo = "BrandCoMarketCo",
    Brand = "Brand",
}
